import { PageMeta } from './models';

export const PAGE_META: { [slug: string]: PageMeta } = {
  "cardiology": {
    "title": "Cardiology Second Opinion | WellSpring",
    "description": "Not sure about your heart diagnosis or treatment plan? Get an independent second opinion from verified cardiologists on WellSpring.",
    "bodyClass": "page-speciality",
    "nav": "doctors"
  },
  "contact": {
    "title": "Contact a Care Navigator | WellSpring",
    "description": "Questions about pricing, records or getting started? Message our Care Navigator team or call Mon–Sat, 9am–7pm MYT. We typically reply within one business day.",
    "bodyClass": "",
    "nav": "contact"
  },
  "create-account": {
    "title": "Create Your Account | WellSpring Second Opinion",
    "description": "Create a WellSpring account for yourself or for a dependent you care for, then start your second opinion case and share medical records securely.",
    "bodyClass": "page-auth page-create-account",
    "nav": ""
  },
  "doctor-cardiology-1": {
    "title": "Dr. Lim Wei Jie, Cardiology | WellSpring",
    "description": "Dr. Lim has spent nearly two decades treating patients with blocked arteries and acute heart attacks. Known for explaining each option plainly, including…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-cardiology-2": {
    "title": "Dr. Nur Aisyah Rahman, Cardiology | WellSpring",
    "description": "Dr. Aisyah focuses on long-term heart health, helping patients review medicines, lifestyle plans and follow-up schedules so that treatment is effective…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-cardiology-3": {
    "title": "Dr. Suresh Nair, Cardiology | WellSpring",
    "description": "Dr. Suresh specialises in heart rhythm problems and is often consulted on whether a pacemaker or ablation is truly needed.",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-gastroenterology-1": {
    "title": "Dr. Kenneth Ong, Gastroenterology | WellSpring",
    "description": "Dr. Ong has spent over a decade evaluating patients with digestive symptoms. Known for explaining what tests are truly needed, interpreting endoscopy…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-gastroenterology-2": {
    "title": "Dr. Siti Mariam Osman, Gastroenterology | WellSpring",
    "description": "Dr. Siti Mariam focuses on liver health and helps patients understand abnormal liver reports and what they mean for the long term. Known for practical…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-gastroenterology-3": {
    "title": "Dr. Arvind Pillai, Gastroenterology | WellSpring",
    "description": "Dr. Arvind works with patients who have long-term bowel conditions and helps them review medicines, flare-ups and follow-up plans. Known for clear…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-mental-health-1": {
    "title": "Dr. Yeoh Pei Shan, Mental Health | WellSpring",
    "description": "Dr. Yeoh has spent many years caring for adults with long-standing and complex mental health conditions. Known for listening closely, reviewing diagnoses…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-mental-health-2": {
    "title": "Dr. Sarah Abdullah, Mental Health | WellSpring",
    "description": "Sarah Abdullah helps patients understand their assessments and whether therapy is right for them, what it involves and how long it usually takes. Known…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-mental-health-3": {
    "title": "Dr. Vikram Selvam, Mental Health | WellSpring",
    "description": "Dr. Vikram works with children, young people and their families and helps parents understand assessments and what support is needed at home and school.…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-neurology-1": {
    "title": "Dr. Chong Mei Ling, Neurology | WellSpring",
    "description": "Dr. Chong has spent over a decade helping patients with seizures and long-standing headaches. Known for reviewing diagnoses carefully, simplifying…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-neurology-2": {
    "title": "Dr. Amir Hakim Yusof, Neurology | WellSpring",
    "description": "Dr. Amir focuses on stroke care, from emergency decisions to long-term prevention. Helps patients and families understand what caused a stroke and how to…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-neurology-3": {
    "title": "Dr. Rajesh Kumar, Neurology | WellSpring",
    "description": "Dr. Rajesh works with patients whose symptoms develop slowly and are hard to pin down. Known for patient history-taking and for explaining what a…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-oncology-1": {
    "title": "Dr. Wong Siew Lan, Oncology | WellSpring",
    "description": "Dr. Wong has spent many years planning drug treatment for patients with solid tumours. Known for reviewing reports carefully, explaining each treatment…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-oncology-2": {
    "title": "Dr. Farid Hamzah, Oncology | WellSpring",
    "description": "Dr. Farid helps patients understand whether surgery is needed, what it involves and what recovery looks like. Known for balanced advice on timing of…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-oncology-3": {
    "title": "Dr. Priyanka Devi, Oncology | WellSpring",
    "description": "Dr. Priyanka explains how radiation works, which type is suitable and what side effects to expect. Often consulted to review whether radiation is needed…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-ophthalmology-1": {
    "title": "Dr. Ng Wei Kiat, Ophthalmology | WellSpring",
    "description": "Dr. Ng has performed thousands of eye surgeries. Known for explaining when cataract surgery is truly needed, how different lens options compare, and what…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-ophthalmology-2": {
    "title": "Dr. Aina Sofea Zulkifli, Ophthalmology | WellSpring",
    "description": "Dr. Aina focuses on conditions of the retina and helps patients understand their scan findings, how urgent treatment is, and what to expect from…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-ophthalmology-3": {
    "title": "Dr. Prakash Raman, Ophthalmology | WellSpring",
    "description": "Dr. Prakash works with patients who need long-term eye monitoring and helps them understand how glaucoma progresses, how treatment protects vision, and…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-orthopaedics-1": {
    "title": "Dr. Daniel Tan Kok Wai, Orthopaedics | WellSpring",
    "description": "Dr. Tan has treated thousands of patients with worn-out knees and hips. Known for explaining all options, including medicines, injections and…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-orthopaedics-2": {
    "title": "Dr. Hafiz Ismail, Orthopaedics | WellSpring",
    "description": "Dr. Hafiz focuses on helping patients understand their MRI findings and whether their symptoms truly need an operation. Many patients are guided towards…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-orthopaedics-3": {
    "title": "Dr. Kavitha Menon, Orthopaedics | WellSpring",
    "description": "Dr. Kavitha works with recreational and competitive athletes as well as active adults, helping them decide between repair, rehabilitation and surgery.",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-profile-1": {
    "title": "Dr. Meera Krishnan, Cardiology | WellSpring",
    "description": "Dr. Meera Krishnan reviews second-opinion cases in coronary artery disease, heart failure and preventive cardiology, including pre-procedure reviews.",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-profile-2": {
    "title": "Dr. Arjun Vellore, Neurology | WellSpring",
    "description": "Dr. Arjun Vellore reviews second-opinion cases involving stroke, epilepsy and neurodegenerative conditions, clarifying diagnosis and treatment options.",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-profile-3": {
    "title": "Dr. Priya Ramasamy, Oncology | WellSpring",
    "description": "Dr. Priya Ramasamy gives independent second opinions on cancer diagnoses and proposed treatment plans before you start or change treatment.",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-respiratory-1": {
    "title": "Dr. Goh Hui Min, Respiratory | WellSpring",
    "description": "Dr. Goh has spent over a decade helping patients manage long-term breathing conditions. Known for reviewing inhaler plans, explaining how triggers affect…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-respiratory-2": {
    "title": "Dr. Azlan Shah Karim, Respiratory | WellSpring",
    "description": "Dr. Azlan focuses on complex lung conditions and helps patients understand their scan findings and whether further tests or procedures are truly needed.",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-respiratory-3": {
    "title": "Dr. Deepa Krishnan, Respiratory | WellSpring",
    "description": "Dr. Deepa works with patients whose breathing problems affect sleep and daily energy, and helps them understand sleep study results and whether device…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-urology-1": {
    "title": "Dr. Jason Lee Chee Keong, Urology | WellSpring",
    "description": "Dr. Lee has treated thousands of patients with kidney stones. Known for explaining whether a stone needs surgery or can be managed with medicines and…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-urology-2": {
    "title": "Dr. Faizal Hamid, Urology | WellSpring",
    "description": "Dr. Faizal helps patients understand reports related to urological cancers and what treatments, including active monitoring, are suitable. Known for…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-urology-3": {
    "title": "Dr. Anand Subramaniam, Urology | WellSpring",
    "description": "Dr. Anand works with patients dealing with sensitive and long-standing urinary and men's health concerns, and provides clear, respectful guidance on…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-womens-health-1": {
    "title": "Dr. Tan Li Ying, Women's Health | WellSpring",
    "description": "Dr. Tan has treated thousands of women with gynaecological conditions. Known for explaining whether surgery is truly needed, which alternatives exist, and…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-womens-health-2": {
    "title": "Dr. Nurul Izzah Hassan, Women's Health | WellSpring",
    "description": "Dr. Nurul Izzah helps expectant mothers understand their reports and options at each stage of pregnancy. Known for calm, clear guidance that helps…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctor-womens-health-3": {
    "title": "Dr. Lakshmi Rajan, Women's Health | WellSpring",
    "description": "Dr. Lakshmi works with women and couples at sensitive stages of life and focuses on explaining tests, treatment options, success rates and realistic…",
    "bodyClass": "",
    "nav": "doctors"
  },
  "doctors": {
    "title": "Our Specialities | WellSpring Second Opinion",
    "description": "Choose your speciality, from cardiology to mental health. See the conditions each covers, when a second opinion helps, and our verified WellSpring specialists.",
    "bodyClass": "",
    "nav": "doctors"
  },
  "faq": {
    "title": "FAQs, Privacy & Trust | WellSpring Second Opinion",
    "description": "Answers about second opinions, submitting your records, the review, your report and pricing, plus how WellSpring protects your health information.",
    "bodyClass": "",
    "nav": "faq"
  },
  "gastroenterology": {
    "title": "Gastroenterology Second Opinion | WellSpring",
    "description": "Unsure About a Digestive or Liver Diagnosis, Or A Recommended Procedure? Get an independent second opinion from verified gastroenterologists on WellSpring.",
    "bodyClass": "page-speciality",
    "nav": "doctors"
  },
  "how-it-works": {
    "title": "How It Works | WellSpring Second Opinion",
    "description": "See the 5-step WellSpring journey: share your case, upload records, get an independent specialist review, choose a report or video consult, then follow-up.",
    "bodyClass": "page-how-it-works",
    "nav": "how-it-works"
  },
  "index": {
    "title": "WellSpring | Expert Second Medical Opinions in Malaysia",
    "description": "Get an independent second medical opinion from verified specialists in Malaysia. Share records securely, get matched by a Care Navigator, receive clear answers.",
    "bodyClass": "page-home",
    "nav": "index"
  },
  "login": {
    "title": "Log In to Your Patient Portal | WellSpring",
    "description": "Log in to your WellSpring patient portal to track your case, upload records, view your second opinion report and message your Care Navigator.",
    "bodyClass": "page-auth page-login",
    "nav": ""
  },
  "mental-health": {
    "title": "Mental Health Second Opinion | WellSpring",
    "description": "Unsure About a Mental Health Diagnosis or Treatment Plan? Get an independent second opinion from verified mental health specialists on WellSpring.",
    "bodyClass": "page-speciality",
    "nav": "doctors"
  },
  "neurology": {
    "title": "Neurology Second Opinion | WellSpring",
    "description": "Unsure about a brain, nerve, or spine diagnosis? Get an independent second opinion from verified neurologists on WellSpring.",
    "bodyClass": "page-speciality",
    "nav": "doctors"
  },
  "oncology": {
    "title": "Oncology Second Opinion | WellSpring",
    "description": "Facing Cancer Diagnosis or Treatment Decision? Get an independent second opinion from verified oncologists on WellSpring.",
    "bodyClass": "page-speciality",
    "nav": "doctors"
  },
  "ophthalmology": {
    "title": "Ophthalmology Second Opinion | WellSpring",
    "description": "Unsure About Eye Diagnosis, or a Recommended Procedure? Get an independent second opinion from verified ophthalmologists on WellSpring.",
    "bodyClass": "page-speciality",
    "nav": "doctors"
  },
  "orthopaedics": {
    "title": "Orthopaedics Second Opinion | WellSpring",
    "description": "Advised Surgery for Your Joint, Bone or Spine Problem? Get an independent second opinion from verified orthopaedic specialists on WellSpring.",
    "bodyClass": "page-speciality",
    "nav": "doctors"
  },
  "respiratory": {
    "title": "Respiratory Second Opinion | WellSpring",
    "description": "Unsure About a Lung or Breathing Diagnosis, or a Recommended Treatment? Get an independent second opinion from verified respiratory specialists on WellSpring.",
    "bodyClass": "page-speciality",
    "nav": "doctors"
  },
  "sample-report-cardiology": {
    "title": "Sample Cardiology Second Opinion Report | WellSpring",
    "description": "Anonymised sample WellSpring report for a coronary artery disease treatment decision: clinical question, records reviewed, options, conclusion and next steps.",
    "bodyClass": "",
    "nav": "services"
  },
  "sample-report-oncology": {
    "title": "Sample Oncology Second Opinion Report | WellSpring",
    "description": "Anonymised sample WellSpring report for a cancer treatment-options review: clinical question, records reviewed, options, conclusion and recommended next steps.",
    "bodyClass": "",
    "nav": "services"
  },
  "sample-report-orthopaedics": {
    "title": "Sample Orthopaedics Second Opinion Report | WellSpring",
    "description": "Anonymised sample WellSpring report for a knee replacement decision: clinical question, records reviewed, treatment options, conclusion and next steps.",
    "bodyClass": "",
    "nav": "services"
  },
  "services": {
    "title": "Our Services & Sample Report | WellSpring",
    "description": "See what a WellSpring second opinion report contains, from executive summary to treatment alternatives, and how follow-up and ongoing care support you.",
    "bodyClass": "page-services",
    "nav": "services"
  },
  "urology": {
    "title": "Urology Second Opinion | WellSpring",
    "description": "Unsure About a Kidney, Bladder or Prostate Diagnosis, or A Recommended Procedure? Get an independent second opinion from verified urologists on WellSpring.",
    "bodyClass": "page-speciality",
    "nav": "doctors"
  },
  "womens-health": {
    "title": "Women's Health Second Opinion | WellSpring",
    "description": "Unsure About a Gynaecological or Reproductive Health Diagnosis, or A Recommended Procedure? Get an independent second opinion from verified women's health…",
    "bodyClass": "page-speciality",
    "nav": "doctors"
  }
};
